export const siteToastMessages = {
  BANNER_CREATED_SUCCESSFULLY: {
    message: "Banner created successfully",
    type: "success",
  },
  BANNER_UPDATED_SUCCESSFULLY: {
    message: "Banner updated successfully",
    type: "success",
  },
  BANNER_DELETED_SUCCESSFULLY: {
    message: "Banner deleted successfully",
    type: "success",
  },
  BANNER_NOT_FOUND: {
    message: "Banner not found",
    type: "error",
  },
  INVALID_BANNER_ID: {
    message: "Invalid banner ID",
    type: "error",
  },
  BANNER_IMAGE_OR_URL_REQUIRED: {
    message: "Please provide either an image file or image URL",
    type: "error",
  },

  // Testimonial messages
  TESTIMONIAL_CREATED_SUCCESSFULLY: {
    message: "Testimonial created successfully",
    type: "success",
  },
  TESTIMONIAL_UPDATED_SUCCESSFULLY: {
    message: "Testimonial updated successfully",
    type: "success",
  },
  TESTIMONIAL_DELETED_SUCCESSFULLY: {
    message: "Testimonial deleted successfully",
    type: "success",
  },
  TESTIMONIAL_NOT_FOUND: {
    message: "Testimonial not found",
    type: "error",
  },
  INVALID_TESTIMONIAL_ID: {
    message: "Invalid testimonial ID",
    type: "error",
  },

  BLOG_NOT_FOUND: {
    message: "Blog not found",
    type: "error",
  },
  BLOG_CREATED_SUCCESSFULLY: {
    message: "Blog created successfully",
    type: "success",
  },
  BLOG_UPDATED_SUCCESSFULLY: {
    message: "Blog updated successfully",
    type: "success",
  },
  BLOG_DELETED_SUCCESSFULLY: {
    message: "Blog deleted successfully",
    type: "success",
  },

  URL_COPIED: {
    message: "URL copied to clipboard!",
    type: "success",
  },
  SELECT_FILES_TO_UPLOAD: {
    message: "Please select files to upload.",
    type: "info",
  },

  IMAGE_UPLOADED_SUCCESSFULLY: {
    message: "Image uploaded successfully",
    type: "success",
  },
  IMAGE_DELETED_SUCCESSFULLY: {
    message: "Image deleted successfully",
    type: "success",
  },

  IMAGE_URL_REQUIRED: {
    message: "Please provide a valid image URL",
    type: "error",
  },

  CASE_STUDY_CREATED_SUCCESSFULLY: {
    message: "Case Study Created Successfully",
    type: "success",
  },

  CASE_STUDY_UPDATED_SUCCESSFULLY: {
    message: "Case Study Updated Successfully",
    type: "success",
  },
  CASE_STUDY_DELETED_SUCCESSFULLY: {
    message: "Case Study Deleted Successfully",
    type: "success",
  },

  DEFAULT: {
    message: "Something went wrong. Please try again.",
    type: "error",
  },
};
